var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_arrow_left_24px",
    d: "M0.795079 1.41L5.37508 6L0.795078 10.59L2.20508 12L8.20508 6L2.20508 -5.24537e-07L0.795079 1.41Z",
    fill: "#FB263B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_arrow_left_24px_2",
    d: "M6.79508 1.41L11.3751 6L6.79508 10.59L8.20508 12L14.2051 6L8.20508 -5.24537e-07L6.79508 1.41Z",
    fill: "#FB263B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLast);
export default __webpack_public_path__ + "static/media/last.26e1a174ff8f735e52731d9a7dce1f14.svg";
export { ForwardRef as ReactComponent };